import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import ReactTooltip from 'react-tooltip';

import styles from './sprite-add-menu.css';

let tooltipIdCounter = 0;

class SpriteAddMenu extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleToggle',
            'handleClickOutside',
            'setContainerRef'
        ]);
        this.state = {isOpen: false};
        this.tooltipId = `sprite-add-menu-${tooltipIdCounter++}`;
    }
    componentDidMount () {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount () {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside (e) {
        if (this.containerRef && !this.containerRef.contains(e.target)) {
            this.setState({isOpen: false});
        }
    }
    handleToggle () {
        this.setState(s => ({isOpen: !s.isOpen}));
    }
    setContainerRef (ref) {
        this.containerRef = ref;
    }
    render () {
        const {className, buttons, tooltipPlace} = this.props;
        const {isOpen} = this.state;
        return (
            <div
                className={`${styles.container} ${className || ''}`}
                ref={this.setContainerRef}
            >
                {isOpen && (
                    <div className={styles.popup}>
                        {buttons.map((btn, i) => {
                            const tipId = `${this.tooltipId}-${i}`;
                            return (
                                <div key={btn.title}>
                                    <button
                                        className={styles.optionBtn}
                                        data-for={tipId}
                                        data-tip={btn.title}
                                        onClick={e => {
                                            // For file-input buttons, keep the menu (and thus the
                                            // <input type="file">) mounted so its change event can
                                            // still fire after the native picker closes. The menu is
                                            // closed by the input's own onChange instead.
                                            if (!btn.fileInput) {
                                                this.setState({isOpen: false});
                                            }
                                            if (btn.onClick) btn.onClick(e);
                                        }}
                                    >
                                        {btn.fileInput && (
                                            <input
                                                accept={btn.fileAccept}
                                                className={styles.fileInput}
                                                multiple={btn.fileMultiple}
                                                ref={btn.fileInput}
                                                type="file"
                                                onChange={e => {
                                                    this.setState({isOpen: false});
                                                    if (btn.fileChange) btn.fileChange(e);
                                                }}
                                            />
                                        )}
                                        <img
                                            className={styles.optionIcon}
                                            draggable={false}
                                            src={btn.img}
                                        />
                                    </button>
                                    <ReactTooltip
                                        className={styles.tooltip}
                                        effect="solid"
                                        id={tipId}
                                        place={tooltipPlace || 'left'}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
                <button
                    className={styles.addBtn}
                    onClick={this.handleToggle}
                >
                    <span className={styles.plus}>+</span>
                </button>
            </div>
        );
    }
}

SpriteAddMenu.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        img: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        fileAccept: PropTypes.string,
        fileChange: PropTypes.func,
        fileInput: PropTypes.func,
        fileMultiple: PropTypes.bool
    })).isRequired,
    className: PropTypes.string,
    tooltipPlace: PropTypes.string
};

export default SpriteAddMenu;
